// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-section_hero___Kx1E","heroLow":"hero-section_heroLow__8knm6","container":"hero-section_container__Uuvyc"};